export class ArbetsorderSearchTexts {
// eslint-disable-next-line sonarjs/public-static-readonly
    static texts = {
        skotningAvstand: "Skotningsavstånd (m)",
        skotningAvstandMin: "MIN",
        skotningAvstandMax: "MAX",
        tradslag: "Trädslag",
        uppdelning: "Uppdelning",
        arbetsorderSkapadFrom: "Arbetsorder skapad fr.o.m",
        arbetsorderSkapadTom: "t.o.m",
        header: "Sök arbetsorder",
        geografi: "Geografi",
        geografiplaceholder: "Välj MO / RO / PO",
        avverkningstyp: "Avverkningsgrupp",
        avverkningstypplaceholder: "Välj avverkningsgrupp",
        ejTidsatta: "Ej Tidsatta",
        fritextsok: "Arbetsorder, åtgärd, vo-nummer",
        fritextsokplaceholder: "Ex: namn, beteckning, nummer",
        anskaffningsform: "Anskaffningsform",
        affarsform: "Affärsform",
        affarsformformplaceholder: "Välj affärsform",
        anskaffningsformplaceholder: "Välj anskaffningsform",
        flerFilter: "Fler filter",
        medelstamMin: "Min",
        medelstamMax: "Max",
        virkeskopplaceholder: "Sök med minst tre tecken",
        virkeskopare: "Virkesköpare",
        kontraktsnummer: "Kontraktsnummer",
        planeradPeriod: "Planerad period",
        produktionsplaneringsstatus: "Produktionsplaneringsstatus",
        produktionsplaneringpagar: "Produktionsplanering pågår",
        redoforproduktion: "Redo för produktion",
        produktionpagar: "Produktion pågår",
        produktiongodkandstatus: "Ajourhållen",
        produktiongodkand: "Visa ajourhållna i Vals",
        produktionsstatus: "Produktionsstatus",
        produktionEjPaborjad: "Produktion ej påbörjad",
        produktionPagar: "Produktion pågår",
        produktionAvslutad: "Produktion avslutad (slutrapport ej inskickad)",
        produktionSlutrapporterad: "Produktion slutrapporterad",
        produktionsdatumFrom: "Produktionsdatum fr.o.m",
        produktionsdatumTom: "t.o.m",
        planeringsstatus: "Planeringsstatus",
        underplanering: "Under planering",
        fardigplanerad: "Färdigplanerad",
        tillganglig: "Tillgänglig",
        tillganglighet: "Tillgänglighet",
        medelstamm3fub: "Medelstam m3fub",
        handelssortimentandgrouplabel: "Handelssortimentgrupp / Handelssortiment",
        showgrotanpassatrv: "Endast grotanpassat rundvirke",
        produktgrupper: "Produktgrupper",
        produktgrupperplaceholder: "Välj en eller flera produktgrupper",
        produktgrupp: "Produktgrupp",
        minstavolym: "Minsta volym",
        grot: "Grot",
        byl:"BYL",
        grotskordad: "Grot skördad",
        grotskordAlla: "Alla",
        grotskordJa: "Skördat",
        grotskordNej: "Planerat",
        grotskorddatum: "Grot skördningsdatum",
        grotfrom: "Från och med",
        grottom: "Till och med",
        grotskotning: "Grotskotning",
        grotskotninginfo: "Verkligt skoglager innebär relaterat rundvirke med produktion godkänd eller fristående Grot",
        grotskotningNej: "Alla",
        grotskotningJa: "Ja",
        grotskotningJaMedRundvirke: "Ja, med verkligt skoglager",
        valtmaskinlag: "Valt maskinlag",
        produktsatt: "Produktsatt",
        destinerad: "Destinerad",
        godkandadrivningspunkter: "Godkända drivningspunkter",
        skickadTillViol: "Skickad till Viol",
        arbetsorderAvslutad: "Arbetsorder avslutad",
        extraordinarhandelse: "Extraordinär Händelse (EOH)",
        voIRask: "vo i rask",
        schemalagd: "Schemalagd",
        minamaskinlag: "Mina maskinlag",
        checkboxJa: "Ja",
        checkboxNej: "Nej",
        rensaFilter: "Rensa filter",
        sok: "Sök",
        sparaSokning: "Spara sökning",
        taBortSokning: "Ta bort sökning",
        bekraftaBorttagAv: "Bekräfta borttag av ",
        detFinnsRedanEnSokning: "Det finns redan en sökning med detta namn",
        garEjAttSparaFlerSokningar: "Det går ej att spara fler sökningar. Du kan ersätta eller ta bort en sökning",
        villDuSkrivaOver: "Vill du skriva över ",
        spara: "Spara",
        angeNamn: "Ange namn",
        avbryt: "Avbryt",
        arbetsorder: "Arbetsorder",
        atgarder: "Åtgärder",
        barighetVag: "Väg",
        barighetSkog: "Skog",
        barighetAnd: "OCH",
        barighetOr: "ELLER",
        filters: {
            skogligData: "Skoglig data",
            arbetsmoment: "Arbetsmoment",
            tid: "Tid",
            grot: "Grot",
            status: "Status",
            virkeskop: "Virkesköp",
            matning: "Mätning"
        },
        virkesorderstatus: "Virkesorderstatus",
        virkesordersyncstatus: "Synkronisering",
        virkesorder: "Virkesorder",
        virkesorderStatus: {
            sand: "Sänd",
            aktiv: "Aktiv",
            fel: "Fel",
            avslutad: "Avslutad",
            uppdateringKravs: "Virkesorder behöver uppdateras"
        },
        matning: {
            mottagare: "Mottagare",
            redovisningshanvisning: "Redovisningshänvisning (Viol3)",
            avtalatMattslag: "Avtalat måttslag"
        },
        virkesorderSkapadFrom: "Virkesorder skapad fr.o.m",
        virkesorderSkapadTom: "T.o.m",
        virkesorderGiltigFrom: "Virkesorder giltig fr.o.m",
        virkesorderGiltigTom: "T.o.m",
        virkesorderAndradFrom: "Virkesorder ändrad fr.o.m",
        virkesorderAndradTom: "T.o.m",
        prislista: "Prislista"
    };
}
